module.exports = __webpack_public_path__ + "img/icon_map_100_off.786395e2.png";